import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Pagination from 'react-js-pagination';
import Constants from '../../shared/constants';
import Layout from '../layout';
import Menubar from '../menubar';
import TestGroupModal from '../modal/testGroupModal';
import { getTestGroupDetails } from '../../actions';

const PAGE_COUNT = 10;

class TestGroupCreation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showTestGroupModal: false,
      editTestGroup: 0,
      page: 1,
      hasAccess: true,
    };
    this.renderPagination = this.renderPagination.bind(this);
  }

  componentDidMount() {
    this.props.getTestGroupDetails().then((data) => {
      this.setState({ hasAccess: data.success });
    });
  }

  renderPagination(testGroup) {
    const { page } = this.state;
    if (testGroup.length > 0 && testGroup.length > PAGE_COUNT) {
      return (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Pagination
            activePage={page}
            itemsCountPerPage={PAGE_COUNT}
            totalItemsCount={testGroup.length}
            pageRangeDisplayed={5}
            onChange={(pageNumber) => this.setState({ page: pageNumber })}
          />
        </div>
      );
    }
    return <div />;
  }

  renderTestGroupListHeader() {
    const headerStyle = {
      border: '1px solid #c5c6c7', borderRight: '1px solid #dedfe0', paddingLeft: 20,
    };
    return (
      <>
        <th style={{ ...headerStyle, textAlign: 'left', width: '20%' }}>Test Group</th>
        <th style={{
          ...headerStyle, textAlign: 'left', width: '20%', paddingLeft: 50,
        }}
        >
          Test Type
        </th>
        <th style={{ ...headerStyle, textAlign: 'left', width: '20%' }}>Test Group Type</th>
        <th style={{ ...headerStyle, textAlign: 'right', width: '20%' }}>Question Count</th>
        <th style={{ ...headerStyle, textAlign: 'right', width: '40%' }}>Test Created So far</th>
      </>
    );
  }

  renderTestGroupData(testGroup) {
    let questionCount = 0;
    Object.values(testGroup.question_count).map((numbers) => {
      questionCount += numbers;
    });
    const notEditable = false;
    return (
      <tr style={{ textAlign: 'center' }}>
        <td
          role="presentation"
          style={{ cursor: notEditable ? 'not-allowed' : 'pointer', color: '#1589FF', textAlign: 'left' }}
          onClick={() => !notEditable
            && this.setState({ editTestGroup: testGroup.id }, () => {
              this.setState({ showTestGroupModal: true });
            })}
        >
          {testGroup.name}
        </td>
        <td style={{ textAlign: 'left' }}>
          {testGroup.test_type.name}
        </td>
        <td style={{ textAlign: 'left' }}>
          {testGroup.is_test ? 'Test' : 'Assignment'}
        </td>
        <td style={{ textAlign: 'right' }}>
          {questionCount}
        </td>
        <td style={{ textAlign: 'right' }}>
          {testGroup.test_taken_so_far}
        </td>
      </tr>
    );
  }

  renderOverviewList() {
    const { page } = this.state;
    const { testGroupDetails } = this.props;
    const minCount = page >= 2 ? (page - 1) * PAGE_COUNT : 0;
    const maxCount = (page) * PAGE_COUNT;
    return (
      <div>
        <div style={{ backgroundColor: '#F5F8FA', width: '1000px' }}>

          <div className="heading-2" style={{ marginTop: 60 }}>
            <div className="heading-1" style={{ paddingBottom: 20, fontSize: 20 }}>
              Test Group
            </div>
            Total Test Group :&nbsp;
            {testGroupDetails.length}
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 20 }}>
            <div
              role="presentation"
              style={{
                height: 35, width: 140, display: 'flex', justifyContent: 'center', alignItems: 'center', border: '1px solid #CDCFD6', borderRadius: 4, cursor: 'pointer',
              }}
              onClick={() => this.setState({ showTestGroupModal: true, editTestGroup: 0 })}
            >
              New Test Group
            </div>
          </div>
          <div className="mt-5">
            <table className="table table-hover" style={{ boxShadow: '1px 2px 6px #8B9DAF33', borderRadius: 4, border: '1px solid #c5c6c7' }}>
              <thead style={{ background: '#F6F8FA', color: '#23394C' }}>
                <tr style={{
                  fontSize: '18px', fontWeight: 700, height: 60, color: '#11426C',
                }}
                >
                  {this.renderTestGroupListHeader()}
                </tr>
                {testGroupDetails.slice(minCount, maxCount).map((testGroup) => {
                  return this.renderTestGroupData(testGroup);
                })}
              </thead>
              <tbody />
            </table>
          </div>
        </div>
      </div>
    );
  }

  noPermission() {
    return (
      <div style={{
        paddingTop: 300,
        paddingLeft: 300,
        width: '100%',
        backgroundColor: '#F5F8FA',
        fontSize: '20px',
      }}
      >
        <span style={{ borderStyle: 'solid', padding: '10px' }}>You dont have permission to access Test Groups </span>
      </div>
    );
  }

  render() {
    const { instituteOnBoardingMenu } = Constants();
    const { showTestGroupModal, editTestGroup, hasAccess } = this.state;
    const { testGroupDetails } = this.props;
    const query = new URLSearchParams(window.location.search);
    const instituteId = query.get('institute_id');
    instituteOnBoardingMenu.forEach((page) => {
      page.route = `${page.route}${instituteId !== null ? `?institute_id=${instituteId}` : ''}`;
    });
    const testGroupData = testGroupDetails.find((testGroup) => parseInt(testGroup.id, 10) === parseInt(editTestGroup, 10));
    return (
      <Layout globalHistory={this.props.history} hideHeader>
        <div
          className="custom-checkbox"
          style={{
            width: '100%', display: 'flex', minHeight: '100vh', backgroundColor: '#F5F8FA',
          }}
        >
          <div style={{ width: '20%', padding: 0, zIndex: 1 }}>
            <Menubar
              history={this.props.history}
              menuList={instituteOnBoardingMenu}
              selectedOption={6}
              redirectToRoot
            />
          </div>
          <div style={{ backgroundColor: '#F5F8FA' }}>
            {hasAccess
              ? (
                <div style={{
                  paddingLeft: 70, width: '100%', backgroundColor: '#F5F8FA',
                }}
                >

                  <TestGroupModal
                    visible={showTestGroupModal}
                    isEdit={editTestGroup > 0}
                    testGroupId={editTestGroup}
                    key={editTestGroup}
                    testGroupData={{ ...testGroupData }}
                    header={editTestGroup > 0 ? 'Edit Test Group' : 'Create Test Group'}
                    submitButton={editTestGroup > 0 ? 'Update' : 'Create'}
                    onClose={() => { this.setState({ showTestGroupModal: false, editTestGroup: 0 }); }}
                  />
                  {this.renderOverviewList()}
                  {this.renderPagination(testGroupDetails)}
                </div>
              )
              : this.noPermission()}
          </div>
        </div>
      </Layout>
    );
  }
}
TestGroupCreation.propTypes = {
  testGroupDetails: PropTypes.array,
};

TestGroupCreation.defaultProps = {
  testGroupDetails: [],
};

const mapStateToProps = ({ institute }) => ({
  testGroupDetails: institute.testGroupDetails,
});

export default connect(mapStateToProps,
  { getTestGroupDetails })(TestGroupCreation);
